export default __webpack_public_path__ + "static/media/rainy.6b753f70.png";